module.exports = __webpack_public_path__ + "img/FR30758.33d50cbe.png";